// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Yn-z","badgeLink":"Zn-z","category":"_n-z"};